import httpClient from './index';

const END_POINT = 'notification/unread';

const getUnreadNotifications = () => httpClient.get(END_POINT);

export { getUnreadNotifications };
